import { Icon } from '@/components/foundations';

/** Cartão "Precisa de ajuda?" da sidebar. `stacked` = ícone acima do texto (telas com drawer). */
export function HelpBox({ stacked = false, href = '#' }: { stacked?: boolean; href?: string }) {
  return (
    <a className={`help-card${stacked ? ' stack' : ''}`} href={href}>
      <Icon name="help" />
      <div>
        <b>Precisa de ajuda?</b>
        <small>
          Acesse nossa central&nbsp;
          <Icon name="ext" />
        </small>
      </div>
    </a>
  );
}
